import React, { useState } from 'react';
import AddLabelModal from './AddLabelModal';
import CreateLabelModal from './CreateLabelModal';
import EditLabelModal from './EditLabelModal';
import WarningModal from '../../../../../common-components/ModalComponent/WarningModal';
import { deleteLabel } from '../../../../../../services/postTracking.service';
import { NotificationManager } from 'react-notifications';
import { useApi } from '../../../../../../hooks/useApi';
import { useDispatch } from 'react-redux';
import { fetchPostTrackingLabels } from '../../../../../../redux/socialListening/socialListeningActions';

const LabellingModal = ({ labelModalOpen, setOpenModal }) => {
  const [selectedLabel, setSelectedLabel] = useState(null);
  const onClose = () => {
    setOpenModal({ post: null, openModal: null });
  };
  const openModal = labelModalOpen.openModal;

  const setActiveModal = (newOpenModal) => {
    setOpenModal((e) => ({ ...e, openModal: newOpenModal }));
  };

  const dispatch = useDispatch();

  const { isLoading: isDeleting, triggerFetch } = useApi(deleteLabel, { type: 'mutation' });

  const onDeleteLabel = async () => {
    const response = await triggerFetch({ args: selectedLabel._id });

    if (response?.status) {
      NotificationManager.success('Deleted Successfully', '', 1200);
      setActiveModal('addLabel');
      setSelectedLabel(null);
      dispatch(fetchPostTrackingLabels());
    } else {
      NotificationManager.error('Error deleting label', '', 1200);
    }
  };

  if (!openModal) return <></>;

  if (openModal === 'addLabel')
    return (
      <AddLabelModal
        setEditLabel={setSelectedLabel}
        show={openModal === 'addLabel'}
        onClose={onClose}
        setActiveModal={setActiveModal}
        post={labelModalOpen?.post}
      />
    );

  if (openModal === 'createLabel')
    return <CreateLabelModal show={openModal === 'createLabel'} onClose={onClose} setActiveModal={setActiveModal} />;

  if (openModal === 'editLabel' && selectedLabel)
    return (
      <EditLabelModal
        editLabel={selectedLabel}
        show={openModal === 'editLabel' && selectedLabel}
        onClose={() => onClose()}
        setActiveModal={setActiveModal}
      />
    );

  if (openModal === 'deleteLabel' && selectedLabel)
    return (
      <WarningModal
        icon="🚨"
        iconBgColor="#FDF4F4"
        title="Delete Label!"
        description={`(${selectedLabel.totalPosts}) posts will no longer have this label.
  Are you sure ?`}
        actionButtonText="Yes, Delete"
        cancelButtonText="Cancel"
        actionFunction={onDeleteLabel}
        onClose={() => setActiveModal('addLabel')}
        actionButtonType="danger"
        show={openModal === 'deleteLabel' && selectedLabel}
        width={374}
        showLoading={isDeleting}
      />
    );
};

export default LabellingModal;
